/**
 *  GummyBear
 *
 *  Created by Legman on 22/02/2017.
 *
 */

import Common       from "./Common";
import PhysicsActor from "./PhysicsActor";

/**
 * @class
 */
export default class GummyBear extends PhysicsActor {
    constructor() {
        const assets = Common.assets;
        const textures = ["gummybear_000", "gummybear_001", "gummybear_002",
            "gummybear_003", "gummybear_004", "gummybear_005", "gummybear_006"];

        super(assets.getTexture(textures[Math.floor(Math.random() * textures.length)]));
    }

    init() {
        super.init();

        TweenMax.to(this.view.scale, 0.24, {
            x: 0.96,
            ease: Power1.easeInOut,
            yoyo: true,
            repeat: -1
        });

        TweenMax.to(this.view.scale, 0.34, {
            y: 0.88,
            ease: Power1.easeInOut,
            yoyo: true,
            repeat: -1
        });
    }

    /**
     * @param {boolean} [destroyChildren]
     */
    destroy(destroyChildren) {
        TweenMax.killTweensOf(this.view.scale);

        super.destroy(destroyChildren);
    }

    /**
     * @returns {p2.Body}
     */
    createBody() {
        const body = new p2.Body({mass: 0.001});
        body.type = p2.Body.DYNAMIC;
        body.allowSleep = true;
        body.sleepSpeedLimit = 4.0;
        body.parent = this;

        const shape = new p2.Box({width: 16, height: 34});
        shape.collisionGroup = PhysicsActor.GUMMY_BEAR;
        shape.collisionMask = PhysicsActor.DEFAULT;
        shape.material = PhysicsActor.MATERIAL_GUMMY_BEAR;

        body.addShape(shape);
        return body;
    }
}
